import { Box, Button, Tooltip } from "@mui/material";

type Props = {
  showCTA?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  openPresentationCTA?: boolean;
  handleClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const Header = ({
  showCTA = true,
  isLoading = false,
  isDisabled = false,
  openPresentationCTA = false,
  handleClick = () => {},
}: Props) => {
  if (openPresentationCTA) {
    return (
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Tooltip
          title={
            isDisabled
              ? `At least one coverage must have the status “Include in Marketing" to update the draft presentation`
              : ""
          }
          disableHoverListener={!isDisabled}
        >
          <span>
            <Button
              onClick={handleClick}
              disabled={isDisabled}
              loading={isLoading}
            >
              Update Draft Presentation
            </Button>
          </span>
        </Tooltip>
      </Box>
    );
  }
  if (showCTA) {
    return (
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Button onClick={handleClick} loading={isLoading}>
          Generate Final Presentation
        </Button>
      </Box>
    );
  }

  return null;
};

export default Header;
